module.exports = __webpack_public_path__ + "img/zoom-out-active.193ed0ea.svg";